import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CustomerInformationResponse } from '@features/termination/interfaces';

@Injectable({
  providedIn: 'root',
})
export class CustomerInformationService {
  private readonly http: HttpClient = inject(HttpClient);

  public getCustomerInformation(): Observable<CustomerInformationResponse> {
    return this.http.get<CustomerInformationResponse>(
      '/serviceinfosclient-wspl/rpc/InfosClient?modeAppel=0',
    );
  }
}
